import { render, staticRenderFns } from "./DiagnosisConsiderationWrapper.vue?vue&type=template&id=7995166e"
import script from "./DiagnosisConsiderationWrapper.vue?vue&type=script&lang=js"
export * from "./DiagnosisConsiderationWrapper.vue?vue&type=script&lang=js"
import style0 from "./DiagnosisConsiderationWrapper.vue?vue&type=style&index=0&id=7995166e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports